/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { useFlags } from 'sarsaparilla';

export function FeatureFlagArray({ flag, flagValueToMatch = '', fallback, children }) {
    const flags = useFlags();
    const flagArray = flags[flag];

    if (typeof flagArray !== 'undefined' && flagArray.includes(flagValueToMatch)) {
        return <>{children}</>;
    }

    return <>{fallback}</> || null;
}

FeatureFlagArray.propTypes = {
    flag: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    fallback: PropTypes.node,
    flagValueToMatch: PropTypes.string.isRequired,
};
